import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, ref } from 'vue';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { useMutation } from '@vue/apollo-composable';
import { InviteResendDocument, InviteType } from '@/gql/graphql';

// --- Props for the component ---
interface Props {
  invite: InviteType;
  show: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InviteResend',
  props: {
    invite: {},
    show: { type: Boolean }
  },
  emits: ['success', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

// --- Computed Properties ---
const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Resend Invite ---
const mutationShowSuccess = ref(false);
const mutationInProgress = ref(false);
const mutationError = ref<string | null>(null);
const {
  mutate: inviteMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(InviteResendDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.inviteResend) {
    console.debug('Invite resent:', res.data.inviteResend);
    // emit event so the parent can refresh the memberships
    mutationShowSuccess.value = true;
    emits('success');
    // close the modal with delay
    setTimeout(() => {
      handleCloseModal();
    }, 2000);
  } else {
    console.error('Invite resend failed:', res.data);
    mutationError.value = `Invite resend failed: ${res.data}`;
  }
});

onMutationError((err) => {
  console.error('Error resending invite:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handlers ---
function resendInvite() {
  mutationError.value = null;
  mutationInProgress.value = true;

  if (!props.invite || !props.invite.id) {
    mutationInProgress.value = false;
    mutationError.value = 'Invalid invite data.';
    return;
  }

  inviteMutation({
    id: props.invite.id,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (props.invite.organization)
    ? (_openBlock(), _createBlock(_unref(BModal), {
        key: 0,
        modelValue: show.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
        onHide: handleCloseModal
      }, {
        title: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'envelope'],
            class: "me-2"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Resend Invite", -1))
        ]),
        footer: _withCtx(() => [
          _createVNode(_unref(BButton), {
            variant: "secondary",
            onClick: handleCloseModal,
            class: "me-2"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("span", null, "Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(BButton), {
            variant: "primary",
            disabled: mutationInProgress.value || mutationShowSuccess.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (resendInvite()))
          }, {
            default: _withCtx(() => [
              (mutationInProgress.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createVNode(_unref(BSpinner), {
                      small: "",
                      label: "",
                      class: "me-1"
                    }),
                    _cache[7] || (_cache[7] = _createTextVNode(" Resending invite ", -1))
                  ]))
                : (mutationShowSuccess.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'check-double'],
                        class: "me-1"
                      }),
                      _cache[8] || (_cache[8] = _createTextVNode(" Invite resent ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'envelope'],
                        class: "me-1"
                      }),
                      _cache[9] || (_cache[9] = _createTextVNode(" Resend invite ", -1))
                    ]))
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _cache[4] || (_cache[4] = _createTextVNode(" Confirm to resend an invite to join ", -1)),
              _createElementVNode("strong", null, _toDisplayString(props.invite.organization.name), 1),
              _cache[5] || (_cache[5] = _createTextVNode(" organization. ", -1))
            ]),
            _createVNode(_unref(BAlert), {
              modelValue: mutationError.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
              variant: "danger",
              dismissible: "",
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(mutationError.value), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})